var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#69d7f9;}.cls-2{fill:none;stroke:#3a00ba;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.12,35.94A12.09,12.09,0,0,1,65,48H32.87a9.66,9.66,0,0,1-9.63-8.84l.54-2.53S24.22,43,34,43s30.54,2.84,36.43-3.92c5-5.79,2.9-11.1,2.18-12.51A12.07,12.07,0,0,1,77.12,35.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.12,35.94A12.09,12.09,0,0,1,65,48H32.87a9.66,9.66,0,0,1-9.63-8.84,7.38,7.38,0,0,1,0-.82,9.67,9.67,0,0,1,9.67-9.67h2.6V26.41a14,14,0,0,1,27.71-2.56H65a12.06,12.06,0,0,1,7.61,2.69h0A12.07,12.07,0,0,1,77.12,35.94Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "40.91 48.04 40.91 51.99 50.16 51.99 59.41 51.99 59.41 48.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "19.01 66.34 19.01 57.68 80.99 57.68 80.99 66.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.16,
    y1: 52,
    x2: 50.16,
    y2: 66.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.55,83.15l-6.28,4.66a2.2,2.2,0,0,1-2.5,0l-6.28-4.66a6.56,6.56,0,0,1-2.38-4.94V65.79H28.93V78.21A6.56,6.56,0,0,1,26.55,83.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.64,72.84V71.68a2.12,2.12,0,0,1,2.12-2.12h.53a2.11,2.11,0,0,1,2.11,2.12v1.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.01,
    y: 73.38,
    width: 10.02,
    height: 6.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.7,83.15l-6.29,4.66a2.18,2.18,0,0,1-2.49,0l-6.29-4.66a6.58,6.58,0,0,1-2.37-4.94V65.79H60.07V78.21A6.58,6.58,0,0,1,57.7,83.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.78,72.84V71.68a2.12,2.12,0,0,1,2.12-2.12h.53a2.12,2.12,0,0,1,2.12,2.12v1.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.15,
    y: 73.38,
    width: 10.02,
    height: 6.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.59,83.15,82.3,87.81a2.18,2.18,0,0,1-2.49,0l-6.29-4.66a6.58,6.58,0,0,1-2.37-4.94V65.79H91V78.21A6.58,6.58,0,0,1,88.59,83.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.67,72.84V71.68a2.12,2.12,0,0,1,2.12-2.12h.53a2.12,2.12,0,0,1,2.12,2.12v1.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.04,
    y: 73.38,
    width: 10.02,
    height: 6.57
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.6c4d4197b45a4413119e67125e64af5e.svg";
export { ForwardRef as ReactComponent };